import { callApi } from '@core/api/apiWrapper'
import { API_BASE_URL } from '@/config'
import store from '@/store'
import type {
  VksCreateRequestBody,
  VksCreateRequestResponse,
  VksRequestStatusResponse,
  VksQueueItemRemoteData,
  VksStartRequestBody,
  VksStartResponse,
  VksConnectRequestBody,
  VksConnectResponse,
  VksCancelRequestBody,
  VksFinishRequestBody,
  VksFinishResponse,
  VksStatus
} from './types'
import type { Paginated } from '@shared/models/types'

export const createVksRequest = async (data: VksCreateRequestBody) => {
  return await callApi<VksCreateRequestResponse>({
    method: 'post',
    url: 'vks/request/',
    data
  })
}

export const getVksRequestStatus = async (id: number) => {
  return await callApi<VksRequestStatusResponse>({
    method: 'get',
    url: `vks/request/${id}/status/`
  })
}

export const getVksQueue = async (params: { course_id: number; status?: VksStatus }) => {
  return await callApi<VksQueueItemRemoteData[] | Paginated<VksQueueItemRemoteData>>({
    method: 'get',
    url: 'vks/requests/',
    params
  })
}

export const startVksSession = async (data: VksStartRequestBody) => {
  return await callApi<VksStartResponse>({
    method: 'post',
    url: 'vks/start/',
    data
  })
}

export const connectVksSession = async (data: VksConnectRequestBody) => {
  return await callApi<VksConnectResponse>({
    method: 'post',
    url: 'vks/connect/',
    data
  })
}

export const cancelVksRequest = async (data: VksCancelRequestBody) => {
  return await callApi({
    method: 'post',
    url: 'vks/cancel/',
    data
  })
}

export const finishVksSession = async (data: VksFinishRequestBody) => {
  return await callApi<VksFinishResponse>({
    method: 'post',
    url: 'vks/finish/',
    data
  })
}

export const sendVksDisconnect = (data: Omit<VksFinishRequestBody, 'reason'>) => {
  const authToken = store.user.auth.getToken()
  const headers: Record<string, string> = {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  }

  if (authToken) headers.Authorization = `Token ${authToken}`

  return fetch(`${API_BASE_URL}vks/finish/`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      ...data,
      reason: 'disconnect'
    }),
    keepalive: true
  }).catch(e => {
    console.error('sendVksDisconnect error', e)
  })
}
